export const SUBJECT_PHOTOS_TEXT = 'LES PHOTOS RATTACHÉES AU SUJET STORY';
